export default __webpack_public_path__ + "static/media/dinersclub.5bb5f70e.jpg";